import { useEffect, useState } from 'react';
import { useHttpClient } from 'src/security/hooks/axiosProvider';

export const useNatureProducts = (projectId?: number | null, activityId?: number | null) => {
  const httpClient = useHttpClient();
  const [natureProducts, setNatureProducts] = useState<any[]>([]);

  useEffect(() => {
    const fetchNatureProducts = async () => {
      try {
        const url = projectId
          ? `/api/project/${projectId}/nature-products${activityId ? `?activityId=${activityId}` : ''}`
          : `/api/nature_product/all`;
        const response = await httpClient.current?.get(url);
        if (response?.data) {
          setNatureProducts(response.data);
        }
      } catch (err) {
        console.error("Erreur API NatureProduct:", err);
      }
    };
    fetchNatureProducts();
  }, [httpClient, projectId, activityId]);

  return { natureProducts };
};